import { render } from "./TransferResultsModal.vue?vue&type=template&id=a67fd1f4"
import script from "./TransferResultsModal.vue?vue&type=script&lang=js"
export * from "./TransferResultsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__